import { DownOutlined, UploadOutlined, UpOutlined } from "@ant-design/icons";
import {
    Button,
  Col,
  Collapse,
  DatePicker,
  Form,
  Input,
  InputNumber,
  notification,
  Radio,
  Row,
  Select,
  Upload,
} from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import classes from "./EtapeDonneesGeneralesFNH.module.css";
import { useContext, useEffect, useState } from "react";
import { getListFormateursByUser, uploadDocumentAffaire } from "../../../../api/geoprod";
import { useLoader } from "../../../../context/LoaderContext";
import GlobalContext from "../../../../context/GlobalContext";
import axiosInstance from "../../../../utils/axios";
const { Panel } = Collapse;

const EtapeDonneesGeneralesFNH = ({form ,typesession,id_session_formation,copieDossierFileList,setCopieDossierFileList}) => {
  const { t } = useTranslation();
    const { isLoading, setIsLoading } = useLoader();
    const [fileList, setFileList] = useState([]);
    const [formateurs, setFormateurs] = useState([]);
      const { gouvernoratOptions} = useContext(GlobalContext);
    const [lieuFormation, setLieuFormation] = useState([{
        id: 1,
        nom: "Centre de formation 1",
    },
    {
        id: 2,
        nom: "Centre de formation 1",
    }]);

    
  const expandIcon = ({ isActive }) =>
    isActive ? <UpOutlined /> : <DownOutlined />;

  const { Option } = Select;
useEffect(() => {
    const fetchData = async () => {
        try {
            setIsLoading(true);
          const response = await getListFormateursByUser();
          const formattedFormateurs = response?.data?.data[0]?.map(item => ({
            value: item.nom + " " + item.prenom,
            label: item.nom + " " + item.prenom,
          }));
          setFormateurs(formattedFormateurs);
          setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            setFormateurs([]);

          notification.error({
            message: t("Erreur"),
            description:
              error?.response?.data?.message ||
              "Une interruption est survenue lors de la récupération des données. Veuillez réessayer.",
            duration: 0,
          });
        }
      };
  
      fetchData();  

}, [])

const handlePreview = async (file) => {
  window.open(file.url, "_blank");
};


const removeFile = () => {
  setCopieDossierFileList([]);
     form.setFieldsValue({
            ...form.getFieldsValue(),
            copie_programme_formation: "",
          });
};


    const uploadFile = async (file, key) => {
       const id_affaire = (typesession === "non_homologuee") ?
           sessionStorage.getItem(
            "id_session_formation_non_homologuee"
          ) :
        sessionStorage.getItem("id_session_formation_continue");
    setIsLoading(true);
    const formData = new FormData();
    formData.append('id_affaire', id_affaire); 
    formData.append('id_type_doc', import.meta.env.VITE_APP_ID_TYPE_DOC);
    formData.append("name_doc", file?.file?.name);
    formData.append("file[]", file?.file);
    formData.append("key", key);

     try {
      const response = await uploadDocumentAffaire(formData);
     if (response?.data?.path) {
  const uploadedFile = {
    uid: file.file.uid,
    name: file.file.name,
    status: "done",
    url: response.data.path,
  };

  setCopieDossierFileList([uploadedFile]);
  form.setFieldsValue({
    copie_programme_formation: [uploadedFile],
  });
  setIsLoading(false);
}

    } catch (error) {
    setIsLoading(false);
      notification.error({
        message: 'Erreur',
        description:
          error?.response?.data?.message ||
          'Une erreur est survenue lors du téléversement du fichier. Veuillez réessayer.',
        duration: 0,
      });
    }

  };
  return (
    <div>
      <Collapse
        bordered={false} 
        defaultActiveKey={["1"]}
        expandIcon={expandIcon}
        expandIconPosition="end" 
        className={classes.container}
      >
        <Panel 
          header={
            <div className={classes.headerStyle}>
              <span>Informations par défaut de la session<span style={{ marginLeft: "0.5rem" }}></span></span>
            </div>
          }
          key="1"
          >
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item label={t("Secteur")} name="secteur">
                <Input disabled />
              </Form.Item>
            </Col>
            {typesession === "non_homologuee" && ( 
              <Col xs={24} sm={12}>
              <Form.Item label={t("Sous-secteur")} name="sous_secteur">
                <Input disabled />
              </Form.Item>
            </Col>
            )}
            
            <Col xs={24} sm={12}>
              <Form.Item label={t("Domaine")} name="domaine">
                <Input disabled />
              </Form.Item>
            </Col>
           
          </Row>
        </Panel>
      </Collapse>

      <Collapse
        bordered={false} 
        defaultActiveKey={["1"]}
        expandIcon={expandIcon}
        expandIconPosition="end" 
        className={classes.container}
      >
        <Panel 
         header={
          <div className={classes.headerStyle}>
            <span>Données à configurer pour la session<span style={{ marginLeft: "0.5rem" }}></span></span>
          </div>
        }
        key="1" >
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Date de début de la session de formation")}
                name="date_debut_session_formation"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder="JJ/MM/AAAA"
                  style={{ width: "100%" }}
                  disabled={id_session_formation}
                  disabledDate={(current) => current && current < dayjs().add(1, 'month').startOf('day')}
                  onCalendarChange={() => {
                    form.setFieldsValue({
                        ...form.getFieldsValue(),
                        date_fin_formation: "",
                      });
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label={t("Date de fin de la session de formation")}
                name="date_fin_session_formation"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder="JJ/MM/AAAA"
                  disabled={id_session_formation}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    const dateDebut = form.getFieldValue("date_debut_session_formation");
                    return current && (!dateDebut || current < dayjs(dateDebut).add(1, "day"));
                  }}
                />
              </Form.Item>
            </Col>


          
            <Col xs={24} sm={12}>
  <Form.Item
    label={t("Lieu de la formation")}
    name="lieu_formation"
    rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
  >
    <Select
      disabled={id_session_formation}
    >
      {typesession === "continue" && (
        <>
          <Option value="EPF">EPF</Option>
          <Option value="autre_adresse">Autre adresse</Option>
        </>
      )}
      {typesession === "non_homologuee" && (
        <>
          <Option value="EPF">EPF</Option>
          <Option value="Annexe">Annexe</Option>
        </>
      )}
    </Select>
  </Form.Item>
</Col>
{typesession === "continue" && <Form.Item
  noStyle
  shouldUpdate={(prev, next) =>
    prev.lieu_formation !== next.lieu_formation
  }
>
  {({ getFieldValue }) =>
    getFieldValue("lieu_formation") === "autre_adresse" ? (
      <Col xs={24} sm={12}>
        <Form.Item
          label={t("Adresse de la formation")}
          name="autre_lieu_formation"
          rules={[
            {
              required: true,
              message: t("Veuillez remplir ce champ."),
            },
          ]}
        >
          <Input.TextArea
            rows={1}
            placeholder=""
            disabled={id_session_formation}
          />
        </Form.Item>
      </Col>
    ) : null
  }
</Form.Item>}

          {typesession === "continue" && (
            <Col xs={24} sm={12}>
               <Form.Item label={t("Gouvernorat")} name="gouvernorat" 
               rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
               >
                <Select
                 disabled={id_session_formation}
                  optionFilterProp="label"
                  showSearch
                  options={gouvernoratOptions}
                />
               </Form.Item>
             </Col>
            )}

            {
              typesession === "continue" && (
              <Col xs={24} sm={12}>
               <Form.Item label={t("Droit de tirage")} name="droit_tirage" 
               rules={[{ required: false, message: t("Veuillez remplir ce champ.") }]}
               >
                <InputNumber
                 disabled={id_session_formation}
               style={{width:"100%"}}

                    min={0}
                  />
               </Form.Item>
             </Col>
              )
            }

            {
              typesession === "continue" && (
              <Col xs={24} sm={12}>
               <Form.Item label={t("Crédit d'impôt")} name="credit_impot" 
               rules={[{ required: false, message: t("Veuillez remplir ce champ.") }]}
               >
                <InputNumber
                 disabled={id_session_formation}
               style={{width:"100%"}}

                    min={0}
                  />
               </Form.Item>
             </Col>
              )
            }
            <Col xs={24} sm={12}>
            <Form.Item label={t("Formateurs")} name="formateurs" rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}>
            <Select mode="multiple" 
                options={formateurs}
                disabled={id_session_formation}

            >
            </Select>
       
      </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item label={t("Nombre des participants")} name="nb_apprenants" rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}>
                <InputNumber   disabled={id_session_formation} style={{ width: "100%" }} min={1}/>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} >
            <Form.Item
  label="Copie programme formation"
  name="copie_programme_formation"
  rules={[{ required: true, message: t("Veuillez téléverser un fichier.") }]}>
  <Upload
    fileList={copieDossierFileList}
    onPreview={handlePreview}
    onRemove={() => removeFile()}
    customRequest={(options) => uploadFile(options, "copie_programme_formation")}
    showUploadList={{
      showPreviewIcon: true,
      showRemoveIcon: true,
    }}
    
                  disabled={id_session_formation}
  >
    <Button 
                  disabled={id_session_formation} icon={<UploadOutlined />}>Copie programme formation</Button>
  </Upload>
</Form.Item>


        
            </Col>

          </Row>
        </Panel>
      </Collapse>
    </div>
  );
};

export default EtapeDonneesGeneralesFNH;
